import { Component, Input, inject,
    ChangeDetectionStrategy
} from '@angular/core';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';

@Component({
    selector: 'app-copy-clipboard-text',
    templateUrl: './copy-clipboard-text.component.html',
    styleUrls: ['./copy-clipboard-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CopyClipboardTextComponent {

    app = inject(MainAppService);

    @Input()
    text = "";

    async copyToClipboard(): Promise<void> {
        await this.app.copyToClipboardOrDialog(this.text, "Text", "Text in Zwischenablage kopiert");
    }
}
